/**
 * SegmentedControl Component - Component Definition
 * ====================================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { SegmentedControlController } from './controller';
import { SEGMENTED_CONTROL_TEMPLATE } from './template';
import { BASE_CLASSES, DEFAULTS, SegmentedControlOption } from './constants';

export interface ISegmentedControlComponentBindings {
  options?: SegmentedControlOption[];
  bg?: boolean;
  onChange?: (args: { value: string }) => void;
}

export const segmentedControlComponentDefinition: IComponentOptions = {
  template: SEGMENTED_CONTROL_TEMPLATE,
  controller: SegmentedControlController,
  require: { ngModelCtrl: '?ngModel' },
  bindings: {
    options: '<',
    bg: '<',
    onChange: '&?'
  }
};

export const MODULE_NAME = 'ec.segmentedControl';

const segmentedControlModule: IModule = angular
  .module(MODULE_NAME, [])
  .component('ecSegmentedControl', segmentedControlComponentDefinition);

export { SegmentedControlController, SEGMENTED_CONTROL_TEMPLATE, BASE_CLASSES, DEFAULTS };

export type { SegmentedControlOption } from './constants';

export default segmentedControlModule;
